<template>
  <div>
    <h3 style="text-align:center;">练习管理</h3>
    <el-card style="width: 1300px; margin: 20px auto 0">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            v-model="keys"
            placeholder="请输入练习题目"
            size="medium"
            clearable
            @keyup.enter.native="getPractice"
          ></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" @click="getPractice" size="medium"
            >查询</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button type="success" @click="addPrictice" size="medium"
            >添加练习题</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="practiceList" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="title" label="练习题标题"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
              >修改练习题</el-button
            >
            <a :href="base + scope.row.url" style="margin: 0 10px" target="_blank">
              <el-button type="success" size="mini">下载</el-button>
            </a>
            <el-button type="warning" size="mini" @click="preview(scope.row)">预览</el-button>
            <el-button type="success" size="mini" @click="handleLog(scope.row)">日志</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加练习题' : '修改练习题'"
      :visible.sync="dialogPractice"
      :width="'800px'"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formPractice" label-width="120px">
        <el-form-item label="练习题标题：">
          <el-input v-model="formPractice.title"></el-input>
        </el-form-item>
        <el-form-item label="上传练习题：">
          <el-upload
            class="upload-demo"
            action
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :file-list="fileListUpload"
            :limit="limitUpload"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
             <span style="color:red;font-size:12px;">*请上传PDF格式的文件</span>
          </el-upload>
         
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogPractice = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="practiceTitle"
      :visible.sync="dialogPreview"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div v-loading="loading">
        <pdf
          :page="pageNum"
          :src="url"
          @progress="loadedRatio = $event"
          @num-pages="pageTotalNum = $event"
        ></pdf>
        <el-button-group style="text-align:center;margin:20px 0;">
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            size="mini"
            @click="prePage"
            >上一页</el-button
          >
          <el-button type="primary" size="mini" @click="nextPage"
            >下一页<i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </el-button-group>
        <div style="margintop: 10px; color: #409eff;text-align:center;">
          {{ pageNum }} / {{ pageTotalNum }}
        </div>
      </div>
    </el-dialog>
  <el-dialog
    title="日志详情"
    :visible.sync="dialogLog"
    :width="'600px'"
    center
    :close-on-click-modal=false>
    <div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input v-model="username" placeholder="请输入用户名" size="medium" clearable @keyup.enter.native="getLog"></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" size="medium" @click="getLog">查询</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="dataLog"
        border
        style="width: 100%;margin-top:20px;">
        <el-table-column
          prop="username"
          label="用户名">
        </el-table-column>
        <el-table-column
          prop="inserttime"
          label="时间">
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="logChange"
          @current-change="lohCurrentChange"
          :current-page="logIndex"
          :page-sizes="[10, 20]"
          :page-size="logSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="logTotal"
        >
        </el-pagination>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  data() {
    return {
      base: "http://fw.hyey.cn",
      keys: "",
      pageIndex: 1,
      limitUpload: 1,
      fileTemp: "",
      flie: "",
      fileListUpload: [],
      dialogPractice: false,
      isAdd: true,
      formPractice: {
        title: "",
        url: "",
      },
      practiceList: [],
      practiceTitle: "",
      pageNum:1,
      pageTotalNum: 1, //总页数
      loadedRatio: 0, // 当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了
      loading:true,
      url:'',
      dialogPreview:false,
      dialogLog:false,
      username:'',
      dataLog:[],
      logId:0,
      logIndex:1,
      logSize:20,
      logTotal:0,
    };
  },
  components: {
    pdf,
  },
    watch:{
    loadedRatio(newVal, oldVal){
      if(newVal==1){
        this.loading=false;
      }else{
        this.loading=true;
      }
    }
  },
  mounted() {
    this.getPractice();
  },
  methods: {
    //添加习题按钮
    addPrictice() {
      this.formPractice = {
        title: "",
        url: "",
      };
      this.fileListUpload = [];
      this.dialogPractice = true;
    },
    //确认添加/修改练习
    submitUp() {
      if (this.formPractice.title == "") {
        this.$message.warning("对不起，您还没有输入练习题目！");
      } else if (this.formPractice.url == "") {
        this.$message.warning("对不起，您还没有上传练习题！");
      } else {
        if (this.isAdd) {
          this.$http
            .post("Exam/AddExamPractice", this.formPractice)
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.dialogPractice = false;
                this.getPractice();
              } else {
                this.$message.error(res.data.message);
              }
            });
        } else {
          this.$http
            .post("Exam/UpdateExamPractice", this.formPractice)
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.dialogPractice = false;
                this.getPractice();
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      }
    },
    // 修改
    handleEdit(rows) {
      this.isAdd = false;
      this.fileListUpload = [];
      this.formPractice.id = rows.id;
      this.formPractice.title = rows.title;
      this.formPractice.url = rows.url;
      this.dialogPractice = true;
    },
    // 删除
    handleDelete(rows) {
      this.$confirm("此操作将会永久删除这个练习题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Exam/DelExamPractice", {
              id: rows.id,
            })
            .then((res) => {
              if (res.data && res.data.isok) {
                this.$message.success(res.data.message);
                this.getPractice();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 获取练习列表
    getPractice() {
      this.$http
        .post("Exam/GetSearchList", {
          keys: this.keys,
          pageIndex: this.pageIndex,
          action: "getExamPracticeht",
        })
        .then((res) => {
          if (res.data && res.data.isok) {
            this.practiceList = res.data.data;
          }
        });
    },
    // 上传文件
    handleChange(file, fileList) {
      //
      this.fileTemp = file.raw;
      let param = new FormData(); // 创建form对象
      param.append("imgFile", this.fileTemp);
      param.append("username", window.sessionStorage.getItem("username"));
      param.append("tokenid", window.sessionStorage.getItem("tokenid"));
      param.append("phone_uuid", window.sessionStorage.getItem("phone_uuid"));
      this.$http
        .post("Dls/UpLoadFile", param, {
          headers: {
            "Content-Type":
              "multipart/form-data;boundary =" + new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.isok) {
            // this.$message.success(res.data.message)
            this.$alert(`<strong>上传成功</strong>`, "提示", {
              dangerouslyUseHTMLString: true,
            });
            this.formPractice.url = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 移除文件前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 移除文件
    handleRemove(file, fileList) {
      //
      this.fileTemp = null;
    },
    // 限制上传个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择1个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 预览
    preview(rows){
      
      this.practiceTitle=rows.title
      this.url=this.base+rows.url
      this.dialogPreview=true
    },
        // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
      // if(page==this.pageTotalNum){
      //   
      // }
    },
    handleLog(rows){
      this.logId=rows.id
      this.getLog()
      this.dialogLog=true
    },
    getLog(){
      this.logIndex=1;
      this.searchLog()
    },
    searchLog(){
      this.$http.post("Exam/GetSearchList",{
        keys:this.usernmae,
        id:this.logId,
        pageIndex:this.logIndex,
        pageSize:this.logSize,
        action:'getExamPracticelog'
      }).then(res=>{
        if(res.data.isok){
          this.dataLog=res.data.data;
          this.logTotal=res.data.recount
        }
      })
    },
    logChange(val){
      this.logSize=val;
      this.searchLog();
    },
    lohCurrentChange(val){
      this.logIndex=val;
      this.searchLog()
    }
  },
};
</script>

<style  lang="less" scoped>
.el-button-group{
  text-align: center;
}
/deep/ .el-dialog--center .el-dialog__body{
  text-align: center !important;
}
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
</style>


// WEBPACK FOOTER //
// src/components/Practice.vue